import { render, staticRenderFns } from "./circulationdoc.vue?vue&type=template&id=27559810"
import script from "./circulationdoc.vue?vue&type=script&lang=js"
export * from "./circulationdoc.vue?vue&type=script&lang=js"
import style0 from "./circulationdoc.vue?vue&type=style&index=0&id=27559810&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports